import type AttachmentModel from "../store/schema/AttachmentModel";
import type AttachmentStore from "../store/schema/AttachmentStore";
import getStore from "../store/store";

export default function getAttachment(attachmentId: {
    Id: string;
} | undefined): AttachmentModel {
    if (!attachmentId) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (11,9): Type 'null' is not assignable to type 'AttachmentModel'.
        // @ts-expect-error
        return null;
    }
    
    const store: AttachmentStore = getStore();
    const attachment = store.attachments.get(attachmentId.Id);
    
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (20,5): Type 'AttachmentModel | undefined' is not assignable to type 'AttachmentModel'.
    // @ts-expect-error
    return attachment;
}
